function isvisible(obj) {
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}
/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
const getPidValue = function (el) {

  let pid;
  const quickViewModal = document.querySelector('#quickViewModal');
  const productSet = document.querySelector('.product-set');

  if (quickViewModal && isvisible(quickViewModal) && !productSet) {
    pid = el.closest('.modal-content').querySelector('.product-quickview').dataset.id;
  } else if (document.querySelector('.product-set-detail') || productSet) {
    pid = el.closest('.product-detail').querySelector('.product-id').innerText;
  } else if (el.dataset.pid) {
    const { pid: pidValue } = el.dataset
    pid = pidValue
  } else {
    pid = document.querySelector('.product-detail:not(.bundle-item)').dataset.id;
  }

  return pid;
};


export default getPidValue;
